import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'; // TODO build a Visit Interface with proper key when we know exactly when we need

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
      fontWeight: 400
    }
  },
  rowCells: {
    fontSize: '1.2rem',
    whiteSpace: 'nowrap'
  },
  divider: {
    width: '10px',
    height: 'auto',
    display: 'inline-block'
  }
});
const useTableStyles = makeStyles({
  headCells: {
    fontWeight: 'bold',
    fontSize: '1.3rem'
  }
});

var _ref = /*#__PURE__*/React.createElement(KeyboardArrowUpIcon, null);

var _ref2 = /*#__PURE__*/React.createElement(KeyboardArrowDownIcon, null);

const Row = ({
  visit,
  onRecordVisit,
  onDocument,
  onOpenMedications
}) => {
  // NOTE default to true
  const [open, setOpen] = React.useState(true);
  const classes = useRowStyles();
  const patientDisplay = visit.lastName && visit.firstName ? `${visit.lastName}, ${visit.firstName} (${visit.patientNumber})` : `Patient ID: ${visit.patientNumber}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableRow, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "expand row",
    size: "small",
    onClick: () => setOpen(!open)
  }, open ? _ref : _ref2)), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.rowCells
  }, new Date(visit.startDate).toLocaleDateString('default', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  })), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.rowCells
  }, visit.isFullDayEvent ? 'All Day Visit' : new Date(visit.startDate).toLocaleTimeString()), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.rowCells
  }, patientDisplay)), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      paddingBottom: 0,
      paddingTop: 0
    },
    colSpan: 6
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 1,
    mt: 1
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 66
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: () => onRecordVisit(visit)
  }, "Record Visit"), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: onDocument
  }, "Document"), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: () => onOpenMedications(visit)
  }, "Medications")))))));
};
/**
 * @component
 * Styled Collapsible Scheduler Table. Pass visits and functions callbacks
 */


export const SchedulerTable = ({
  visits,
  onRecordVisit,
  onDocument,
  onOpenMedications
}) => {
  const classes = useTableStyles();
  return /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "collapsible table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      width: '1%'
    }
  }), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      width: '1%'
    },
    className: classes.headCells
  }, "Date"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      width: '1%'
    },
    className: classes.headCells
  }, "Time"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      width: '97%'
    },
    className: classes.headCells
  }, "Patient"))), /*#__PURE__*/React.createElement(TableBody, null, visits.map((visit, index) => /*#__PURE__*/React.createElement(Row // eslint-disable-next-line react/no-array-index-key
  , {
    key: `${visit.id}-${index}`,
    visit: visit,
    onRecordVisit: () => onRecordVisit(visit),
    onOpenMedications: () => onOpenMedications(visit),
    onDocument: onDocument
  })))));
};
export default SchedulerTable;